@if (toastList.length > 0) {
<div class="toast-container">
	@for (toast of toastList; track $index) {
	<div
		 class="toast-message-wrapper toast-fade-in"
		 [class]="toast.type"
		 (mouseenter)="pauseToastTimer(toast)"
		 (mouseleave)="resumeToastTimer(toast)">
		<div class="message-icon-wrapper">
			@switch (toast.type) {
			@case (ToastType.Success) {
			<i class="far fa-circle-check toast-icon" [class]="toast.type"></i>
			}
			@case (ToastType.Error) {
			<i class="far fa-circle-exclamation toast-icon" [class]="toast.type"></i>
			}
			@case (ToastType.Info) {
			<i class="far fa-circle-info toast-icon" [class]="toast.type"></i>
			}
			}
			<p class="toast-message" [class]="toast.type">{{ toast.message }}</p>
		</div>
		@if (toast.dismiss) {
		<div>
			<button
					data-qa="preview-prompt-button"
					disableRipple="true"
					mat-button
					(click)="hideToastMessage(toast)"
					aria-label="Close Toast">
				<i class="fa-classic fa-close remove-icon" [class]="toast.type"></i>
			</button>
		</div>
		}
		<div class="grow"></div>
	</div>
	}
</div>
}